module.exports = __webpack_public_path__ + "static/DC3-73907a994ae6ba8a839684463c8472d2.jpg";